import { AxiosError, AxiosResponse } from "axios";
import React, { ChangeEvent } from "react";
import Avatar from "react-avatar";
import { toast } from "react-toastify";
import { BankUserContext } from "../../../bankUserContext";
import {
  ICaseCommentModel,
  ICaseDetailsModel,
  ICaseDocumentModel,
} from "../../../models/Cases/CaseDetailsModel";
import { catchError } from "../../../utils/Utils";
import CaseCommentInnerFC from "./CaseCommentInnerFC";
import CaseDocuments from "./CaseDocuments";
import CommentMentions from "../../../commonfields/CommentMentions";
import Service from "../../../services";
import { catchErrorGeneric } from "../../../utils/GeneralUtils";

interface ICaseCommentsRCProps {
  caseDetails: ICaseDetailsModel | null;
  disableforsuperuser: boolean;
  suggestedUsersList: any;
  getAllManualTodoUsers: () => void;
}

interface ICaseCommentsRCState {
  commentInput: string;
  commentsData: ICaseCommentModel[] | [];
  tabs: string; // Todo: change to enum
  caseDocuments: ICaseDocumentModel[] | [];
  caseDocumentsSearch: string;
  commentsSearch: string;
  suggestedUsers: string[];
}

class CaseCommentsRC extends React.Component<
  ICaseCommentsRCProps,
  ICaseCommentsRCState
> {
  static contextType = BankUserContext;
  service = new Service();
  context: React.ContextType<typeof BankUserContext> | undefined;
  // roles = new RolesAuthentication();

  constructor(props: ICaseCommentsRCProps) {
    super(props);
    this.state = {
      commentInput: "",
      commentsData: [],
      tabs: "commentsData",
      caseDocuments: [],
      caseDocumentsSearch: "",
      commentsSearch: "",
      suggestedUsers: [],
    };
  }

  componentDidUpdate(
    prevProps: ICaseCommentsRCProps,
    prevState: ICaseCommentsRCState
  ) {
    if (
      (this.props?.caseDetails &&
        this.props?.caseDetails?.caseId !== prevProps?.caseDetails?.caseId) ||
      prevState.commentsSearch !== this.state.commentsSearch
    ) {
      this.getCaseCommentsByCaseId();
    }
  }

  getCaseCommentsByCaseId = () => {
    this.props?.caseDetails &&
      this.service
        .getCaseCommentsByCaseId(
          this.props?.caseDetails?.caseId,
          this.state.commentsSearch
        )
        .then((response: AxiosResponse<ICaseCommentModel[]>) =>
          this.setState({
            commentsData: response?.data,
          })
        )
        .catch((er: AxiosError) => catchError(er, true));
  };

  handleCommentChange = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({ commentInput: e.target.value });
  };

  handleCommentSearch = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({ commentsSearch: e.target.value });
  };

  saveComment = (e: any) => {
    e.preventDefault();
    if (this.props?.caseDetails && this.state.commentInput.trim() !== "") {
      const usersList = this.state.suggestedUsers?.filter((each) =>
        this.state.commentInput?.includes(each)
      );
      const requestObj = {
        caseId: this.props?.caseDetails?.caseId,
        comment: this.state.commentInput,
        userId: usersList || [],
      };
      this.service
        .addCaseComment(requestObj)
        .then(() => {
          this.setState({
            commentInput: "",
            suggestedUsers: [],
          });
          this.getCaseCommentsByCaseId();
        })
        .catch((error: AxiosError) => catchError(error, true));
    }
  };

  deleteComment = (commentId: any) => {
    this.service
      .deleteCaseComment(commentId)
      .then(() => {
        this.getCaseCommentsByCaseId();
        this.setSuggestedUsers([]);
      })
      .catch((error: AxiosError) => catchError(error, true));
  };

  updateComment = (commentId: string, comment: string) => {
    if (this.props?.caseDetails && comment.trim() !== "") {
      const usersListUpdate = this.state.suggestedUsers?.filter((each) =>
        comment?.includes(each)
      );
      const updateComment = {
        commentId: commentId,
        caseId: this.props?.caseDetails?.caseId,
        comment: comment,
        userId: usersListUpdate || [],
      };
      console.log(this.state.suggestedUsers);
      console.log(updateComment);
      this.service
        .updateCaseCommentByCommentId(updateComment)
        .then(() => {
          this.getCaseCommentsByCaseId();
          this.setSuggestedUsers([]);
        })
        .catch((error: AxiosError) => catchError(error, true));
    }
  };

  tabsNavigation = (value: string) => {
    this.setState({ tabs: value });
  };

  getCaseDocumentsList = (commentInput: string) => {
    if (this.props?.caseDetails) {
      this.service
        .getCaseDocumentsList(this.props.caseDetails?.caseId)
        .then((res) =>
          this.setState({
            caseDocuments: res?.data?.filter((each) =>
              each?.documentName?.toLowerCase()?.includes(commentInput.toLowerCase())
            ),
          })
        )
        .catch((error: AxiosError) => catchError(error, true));
    } else catchErrorGeneric("Something went wrong");
    // toast.error('Something went wrong')
  };

  handleCaseDocumentsSearch = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({ caseDocumentsSearch: e.target.value });
    this.getCaseDocumentsList(e?.target?.value);
  };

  addSuggestedUsers = (id: string) => {
    if (!this.state.suggestedUsers?.includes(id)) {
      this.setState({ suggestedUsers: [...this.state.suggestedUsers, id] });
    }
  };

  setSuggestedUsers = (value: string[] | []) =>
    this.setState({ suggestedUsers: value });

  clearComment = () => {
    this.setState({
      commentInput: "",
      suggestedUsers: [],
    });
  };

  render() {
    const context = this.context;
    const { commentsData, commentsSearch } = this.state;
    return (
      <div className="commentsSection caseComments">
        <div className="d-flex tabs">
          <div
            className={
              this.state.tabs === "commentsData"
                ? `commentsheadingContainer`
                : `unselectedContainer`
            }
            onClick={() => {
              this.props?.getAllManualTodoUsers &&
                this.props.getAllManualTodoUsers();
              this.tabsNavigation("commentsData");
            }}
          >
            <p className="commentsheading">Comments</p>
          </div>
          <div
            className={
              this.state.tabs === "CaseDocuments"
                ? `commentsheadingContainer`
                : `unselectedContainer`
            }
            onClick={() => {
              this.getCaseDocumentsList(this.state.caseDocumentsSearch);
              this.tabsNavigation("CaseDocuments");
            }}
          >
            <p className="commentsheading">Case Documents</p>
          </div>
        </div>
        <div className="commentscontainer">
          {this.state.tabs === "commentsData" ? (
            <>
              <div className="caseDocumentSearch">
                <div className="commentsCount">
                  {commentsData?.length || 0} Total Comments
                </div>
                <input
                  type="text"
                  id="search"
                  value={commentsSearch}
                  onChange={this.handleCommentSearch}
                  placeholder={`Search`}
                />
              </div>
              <div className="commentsEntryContainer d-flex">
                <Avatar
                  size="32px"
                  round
                  name={`${context?.bankuserDetails?.firstName} ${context?.bankuserDetails?.lastName}`}
                />
                <div className="formContainer">
                  <CommentMentions
                    placeholder="Add a Comment"
                    value={this.state.commentInput}
                    handleChange={this.handleCommentChange}
                    data={this.props?.suggestedUsersList || []}
                    onAdd={this.addSuggestedUsers}
                  />
                  {
                    <div className="editformcontainer">
                      <button type="button" onClick={this.saveComment}>
                        Add
                      </button>
                      <button type="button" onClick={this.clearComment}>
                        Clear
                      </button>
                    </div>
                  }
                </div>
              </div>
              <ul className="bankusercommentscontainer">
                {commentsData?.map((comment: ICaseCommentModel) => (
                  <CaseCommentInnerFC
                    comment={comment}
                    key={comment?.caseCommentId}
                    deleteComment={this.deleteComment}
                    updateComment={this.updateComment}
                    data={this.props?.suggestedUsersList}
                    onAdd={this.addSuggestedUsers}
                    setSuggestedUsers={this.setSuggestedUsers}
                  />
                ))}
                {commentsData.length === 0 && (
                  <div className="noCommentscontainer">
                    <p>No Comments Data to show</p>
                  </div>
                )}
              </ul>
            </>
          ) : (
            <div className="caseDocumentsContainer">
              {" "}
              <div className="body-section">
                <div className="message-container">
                  <CaseDocuments
                    caseDocuments={this.state.caseDocuments}
                    caseDocumentsSearch={this.state.caseDocumentsSearch}
                    handleCaseDocumentsSearch={this.handleCaseDocumentsSearch}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CaseCommentsRC;
